module.exports = __webpack_public_path__ + "img/74.1c9ce19c.jpg";